import cn from 'classnames';
import React, {useMemo, useRef, useState} from 'react';
import iArrow from '../../../assets/images/arrow.svg';
import {useOutsideClick} from '../../hooks';
import './select.sass';

type TOption = {
  label: string;
  value: string;
  icon?: string;
};

interface IProps {
  className?: string;
  onChange: (e: any) => void;
  value: string;
  name: string;
  options: TOption[];
  disabled?: boolean;
}

const Select = React.forwardRef<HTMLDivElement, IProps>(({className, disabled, onChange, options, value, name}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const ref = useRef<HTMLDivElement>(null);
  const selected = useMemo(() => {
    return options.find(el => el.value === value) || {label: 'Select token', value: ''};
  }, [options, value]);

  useOutsideClick(ref, () => setIsOpen(false));
  const togglePopup = () => {
    if (disabled) return;

    setIsOpen(state => !state);
  };
  return (
    <div className={cn('select', className)}>
      <div className={cn('select__item', {_open: isOpen})} onClick={togglePopup}>
        {selected?.icon && <img className="select__item-icon" src={selected?.icon} alt={selected.label} />}
        <div className="select__item-label">{selected?.label}</div>
        <img src={iArrow} alt={'arrow'} />
      </div>
      <div ref={ref} className={cn('select__popup', {_open: isOpen})}>
        {options.map(el => (
          <div
            className="select__popup-item"
            onClick={() => {
              onChange({
                target: {
                  value: el.value,
                  name,
                },
                type: 'text',
              });
              setIsOpen(false);
            }}
          >
            {selected && <img className="select__item-icon" src={el?.icon} alt={el.label} />}
            {el.label}
          </div>
        ))}
      </div>
    </div>
  );
});

export default Select;
